import type { FilterDefinition, FilterHandler } from '../engine/types';
import { FilterId, FilterType, type ListFilter } from '../types/filters';

export const founderEthnicityDefinition: FilterDefinition<ListFilter> = {
  id: FilterId.FOUNDER_ETHNICITY,
  name: 'Founder Ethnicity',
  selectionListId: 'ethnicity',
  selections: [],
  type: FilterType.LIST,
  isVisible: true,
};

export const founderEthnicityHandler: FilterHandler<ListFilter> = {
  isActive(currentFilterState: ListFilter) {
    return currentFilterState.selections.length > 0;
  },
  isDefault(currentFilterState: ListFilter) {
    return currentFilterState.selections.length === 0;
  },
  getEffectiveFilter(currentFilterState: ListFilter): ListFilter {
    return currentFilterState;
  },
  getRequiredSelectionListIds(definition: FilterDefinition<ListFilter>) {
    return [definition.selectionListId];
  },
};
